import { NgModule, isDevMode } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { RouteReuseStrategy } from "@angular/router";

import { CoreModule } from "./core/core.module";

import { IonicModule, IonicRouteStrategy } from "@ionic/angular";
import { IonicStorageModule } from "@ionic/storage-angular";
import { Drivers } from "@ionic/storage";

import { RouterModule } from "@angular/router";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { HintModule } from "./hints/hint.module";

import { JsonDataService } from "./shared/json-data.service";
import { AngularSvgIconModule } from "angular-svg-icon";

import { provideHttpClient, withFetch } from "@angular/common/http";
import { environment } from "../environments/environment";

import { AngularFireModule } from "@angular/fire/compat";
import { AngularFireAuthModule } from "@angular/fire/compat/auth";
import { AngularFirestoreModule } from "@angular/fire/compat/firestore";

import { GooglePlus } from "@awesome-cordova-plugins/google-plus/ngx";
import { HomeLayoutComponent } from "./layouts/home-layout/home-layout.component";
import { SharedModule } from "./shared/shared.module";
import { AlertModalComponent } from "./pages/alert-modal/alert-modal.component";
import { ServiceWorkerModule } from "@angular/service-worker";
import {
  AngularFireAnalyticsModule,
  ScreenTrackingService,
  UserTrackingService,
} from "@angular/fire/compat/analytics";

@NgModule({
  declarations: [AppComponent, HomeLayoutComponent, AlertModalComponent],
  imports: [
    BrowserModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    RouterModule,
    AngularSvgIconModule.forRoot(),
    IonicStorageModule.forRoot({
      name: "__mydb",
      driverOrder: [Drivers.IndexedDB, Drivers.LocalStorage],
    }),
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFireAuthModule,
    AngularFirestoreModule,
    AngularFireAnalyticsModule,
    SharedModule,
    CoreModule,
    HintModule,
    ServiceWorkerModule.register("ngsw-worker.js", {
      enabled: !isDevMode(),
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: "registerWhenStable:30000",
    }),
  ],
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideHttpClient(withFetch()),
    JsonDataService,
    GooglePlus,
    ...environment.firebaseProviders,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
